import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';

import './locale/fr.js';

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default dayjs;
